export default __webpack_public_path__ + "static/automobile-exhibition-timer-4cc669ab817db86cb50b7e858073af6b.gif";